import { render, staticRenderFns } from "./FrontEndPriceChart.vue?vue&type=template&id=bc08127e&scoped=true&"
import script from "./FrontEndPriceChart.vue?vue&type=script&lang=js&"
export * from "./FrontEndPriceChart.vue?vue&type=script&lang=js&"
import style0 from "./FrontEndPriceChart.vue?vue&type=style&index=0&id=bc08127e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc08127e",
  null
  
)

export default component.exports